const popup = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 80 // 0-100
    }
  },
  data() {
    return {
      myVisible: false
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.myVisible = newVal
      },
      immediate: true
    }
  },
  methods: {
    hidePopup() {
      this.myVisible = false
      this.$emit('update:visible', false)
      this.$emit('close', false)
    }
  }
}

export { popup }
